export default "__VITE_ASSET__bc896c33__"